module.exports = __webpack_public_path__ + "static/media/PayPalGray.e5280260.svg";